// extracted by mini-css-extract-plugin
module.exports = {"CultureContainer":"style_CultureContainer__1uQWI","CultureSection":"style_CultureSection__3t7C0","CultureEnTitle":"style_CultureEnTitle__1vDcX"};